/** Colores por sección — gradientes para menú activo, cabeceras e iconos. */

export const NAV_SECTIONS = {
  panel: { label: "Panel", from: "239 84% 67%", to: "258 90% 66%" },
  planificacion: { label: "Planificación", from: "199 89% 48%", to: "217 91% 60%" },
  vacaciones: { label: "Vacaciones", from: "38 92% 50%", to: "25 95% 53%" },
  organizacion: { label: "Organización", from: "239 84% 67%", to: "292 84% 61%" },
  fichajes: { label: "Fichajes", from: "239 84% 67%", to: "258 90% 66%" },
  solicitudes: { label: "Solicitudes", from: "347 77% 50%", to: "330 81% 60%" },
  comunicados: { label: "Comunicados", from: "199 89% 48%", to: "217 91% 60%" },
  empleados: { label: "Empleados", from: "189 94% 43%", to: "217 91% 60%" },
  turnos: { label: "Turnos y festivos", from: "258 90% 66%", to: "270 95% 60%" },
  zonas: { label: "Zonas de trabajo", from: "142 71% 45%", to: "160 84% 39%" },
  informes: { label: "Listados e informes", from: "84 81% 44%", to: "160 84% 39%" },
  horas: { label: "Horas semanales", from: "160 84% 39%", to: "173 80% 40%" },
  documentos: { label: "Documentación", from: "215 16% 40%", to: "240 5% 34%" },
  proyectos: { label: "Proyectos", from: "258 90% 66%", to: "270 95% 60%" },
  gastos: { label: "Gastos", from: "160 84% 39%", to: "173 80% 40%" },
  rutas: { label: "Rutas comerciales", from: "347 77% 50%", to: "25 95% 53%" },
  ajustes: { label: "Ajustes", from: "240 5% 34%", to: "240 6% 10%" },
  empresas: { label: "Empresas", from: "239 84% 57%", to: "217 91% 53%" },
  plantillas: { label: "Plantillas", from: "347 77% 50%", to: "350 89% 60%" },
  configuracion: { label: "Configuración", from: "258 90% 58%", to: "270 95% 55%" },
  apk: { label: "App Android", from: "239 84% 57%", to: "258 90% 66%" },
};

export const INFORME_SECTIONS = {
  dashboard: { label: "Cuadro de mando", from: "239 84% 67%", to: "258 90% 66%" },
  balance: { label: "Balance de horas", from: "160 84% 39%", to: "173 80% 40%" },
  fichajes: { label: "Histórico de fichajes", from: "199 89% 48%", to: "217 91% 60%" },
  incidencias: { label: "Incidencias", from: "38 92% 50%", to: "25 95% 53%" },
  ausencias: { label: "Ausencias", from: "347 77% 50%", to: "330 81% 60%" },
  registro_jornada: { label: "Registro de jornada", from: "215 16% 35%", to: "240 5% 34%" },
  analisis_pausas: { label: "Análisis de pausas", from: "38 92% 50%", to: "25 95% 53%" },
  compensaciones: { label: "Compensaciones", from: "258 90% 66%", to: "270 95% 60%" },
  picados_proyectos: { label: "Picados por proyecto", from: "258 90% 66%", to: "270 95% 60%" },
};

export const KPI_SECTIONS = {
  empleados: { label: "Empleados", from: "239 84% 67%", to: "258 90% 66%" },
  trabajando: { label: "Trabajando", from: "160 84% 39%", to: "173 80% 40%" },
  ausentes: { label: "Ausentes", from: "38 92% 50%", to: "25 95% 53%" },
  horas: { label: "Horas", from: "199 89% 48%", to: "217 91% 60%" },
  pendientes: { label: "Pendientes", from: "38 92% 50%", to: "25 95% 53%" },
  horas_trabajadas: { label: "Horas trabajadas", from: "160 84% 39%", to: "173 80% 40%" },
  bolsa: { label: "Bolsa / saldo", from: "199 89% 48%", to: "217 91% 60%" },
  horas_extra: { label: "Horas extra", from: "38 92% 50%", to: "25 95% 53%" },
  compensadas: { label: "Compensadas", from: "258 90% 66%", to: "270 95% 60%" },
  extra_pendiente: { label: "Extra pendiente", from: "292 84% 61%", to: "330 81% 60%" },
  dias_ausencia: { label: "Días ausencia", from: "347 77% 50%", to: "330 81% 60%" },
  fichajes_manuales: { label: "Fichajes manuales", from: "25 95% 53%", to: "0 84% 60%" },
  sesiones_abiertas: { label: "Sesiones abiertas", from: "45 93% 47%", to: "38 92% 50%" },
};

function injectSectionTokens(target, sections, prefix = "") {
  Object.entries(sections).forEach(([key, { from, to }]) => {
    const full = prefix ? `${prefix}${key}` : key;
    target[`sec-${full}-from`] = from;
    target[`sec-${full}-to`] = to;
  });
}

export function flatSectionDefaults() {
  const out = {};
  injectSectionTokens(out, NAV_SECTIONS);
  injectSectionTokens(out, INFORME_SECTIONS, "informe-");
  injectSectionTokens(out, KPI_SECTIONS, "kpi-");
  return out;
}

function sectionDefaults(key) {
  if (NAV_SECTIONS[key]) return NAV_SECTIONS[key];
  if (key.startsWith("informe-")) {
    const id = key.slice(8);
    return INFORME_SECTIONS[id];
  }
  if (key.startsWith("kpi-")) {
    const id = key.slice(4);
    return KPI_SECTIONS[id];
  }
  return NAV_SECTIONS.panel;
}

function hslPart(key, part) {
  const def = sectionDefaults(key);
  const fallback = part === "from" ? def.from : def.to;
  return `var(--sec-${key}-${part}, ${fallback})`;
}

/** Gradiente lineal de una sección (menú activo, cabecera, tarjeta). */
export function sectionGradientStyle(key, direction = "to right") {
  return {
    background: `linear-gradient(${direction}, hsl(${hslPart(key, "from")}), hsl(${hslPart(key, "to")}))`,
  };
}

/** Fondo suave del icono inactivo en el menú lateral. */
export function sectionIconInactiveStyle(key) {
  return {
    background: `hsl(${hslPart(key, "from")} / 0.14)`,
    color: `hsl(${hslPart(key, "to")})`,
  };
}

export function informeSectionKey(tipoId) {
  return `informe-${tipoId}`;
}

export function kpiSectionKey(kpiId) {
  return `kpi-${kpiId}`;
}
